import React from "react";

const VerifyError = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h2>❌ Verification failed or expired link</h2>
    <p>Please check your email for a valid verification link or contact support.</p>
  </div>
);

export default VerifyError;
